import React from 'react';
import { TooltipProps } from 'recharts';

import { Stack } from '../../Stack/Stack';

import './ChartTooltip.css';

interface Props extends TooltipProps<number, string> {
  labels: string[];
}

export function ChartTooltip({ label, active, payload, labels }: Props): JSX.Element | null {
  if (!active || !payload) {
    return null;
  }

  return (
    <div className="chart-tooltip">
      <p className="chart-tooltip__heading">{label}</p>

      <Stack size="xxs">
        {payload.map((p, idx) => (
          <Stack size="xxxs" key={idx}>
            <Stack line size="xxxs">
              <svg width="10px" height="10px">
                <circle cx="5" cy="5" r="4" fill={p.stroke} />
              </svg>
              <p className="">{labels[idx]}</p>
            </Stack>
            <p className="tooltip__value">{p.value}</p>
          </Stack>
        ))}
      </Stack>
    </div>
  );
}
